import * as React from 'react';
import {useInteractions, type UseListNavigationProps} from '@floating-ui/react';
import {noop} from 'lodash';

type MenuContentContextType = {
  activeIndex: UseListNavigationProps['activeIndex'];
  getItemProps: ReturnType<typeof useInteractions>['getItemProps'];
  isOpen: boolean;
  menuItemNote: string | null;
  menuItemNoteHeight: number;
  notePortalRef?: React.RefObject<HTMLDivElement | null>;
  setActiveIndex: UseListNavigationProps['onNavigate'];
  setMenuItemNote: React.Dispatch<React.SetStateAction<string | null>>;
  setMenuItemNoteHeight: React.Dispatch<React.SetStateAction<number>>;
  setStaticMenuNoteHeight: React.Dispatch<React.SetStateAction<number>>;
  isWithinMenuContent: boolean;
};

export const MenuContentContext = React.createContext<MenuContentContextType>({
  activeIndex: null,
  getItemProps: () => ({}),
  isOpen: false,
  menuItemNote: null,
  menuItemNoteHeight: 0,
  setActiveIndex: noop,
  setMenuItemNote: noop,
  setMenuItemNoteHeight: noop,
  setStaticMenuNoteHeight: noop,
  isWithinMenuContent: false,
});

export const useMenuContentContext = (): MenuContentContextType => {
  const context = React.useContext(MenuContentContext);
  const isTestEnvironment = process.env.NODE_ENV === 'test';

  if (!context && !isTestEnvironment) {
    throw new Error('You must use component within Menu Content Context');
  }

  return context;
};
